export default `
§ page.settings.document.title: 디스플레이 설정
§ page.settings.document.name: 페이지 제목
§ page.settings.document.language: 인터페이스 언어
§ page.settings.document.depersonalize: 개인 데이터 숨기기
§ page.settings.links.title: 링크 접두사
§ page.settings.links.task: 작업 번호
§ page.settings.links.pr: 홍보
§ page.settings.user.title: 개별 설정
§ page.settings.user.notFound: 개별 설정이 없습니다. 모든 직원에 대한 데이터는 공통 매개 변수를 사용하여 계산됩니다.
§ page.settings.user.subTitle: 고용 계약 제 1 호의 부록
§ page.settings.user.from: 작업 시작 날짜
§ page.settings.mailmap: 설정.메일맵
§ page.settings.common.title: 일반 급여 데이터
§ page.settings.common.type.title: 프로젝트 작업 유형
§ page.settings.common.type.full: 풀 타임 고용
§ page.settings.common.type.part: 프로젝트 작업
§ page.settings.common.salary: 월급(미국 달러)
§ page.settings.common.currency: 표시할 통화
§ page.settings.common.workDaysInYear: 년 당 작업 일의 수
§ page.settings.common.vacationDaysInYear: 연간 휴가 일 수
§ page.settings.common.workDaysInWeek: 작업 일
§ page.settings.form.save: 저장
§ page.settings.form.cancel: 취소
§ page.settings.form.remove: 제거
§ page.settings.form.addEmployee: 직원 추가
§ page.settings.form.addContract: 고용 계약 추가
`;
